import { lazy, Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "./context/CartContext";
import { OrderHistoryProvider } from "./context/OrderHistoryContext";
import ScrollToTop from "./components/feature/ScrollToTop";
import TryOnSessionWatcher from "./components/feature/TryOnSessionWatcher";
import RouteMetadata from "./components/feature/RouteMetadata";
import BehaviorAnalytics from "./components/feature/BehaviorAnalytics";
import CookieConsent from "./components/feature/CookieConsent";
const StyleAssistantWidget = lazy(() => import("./components/feature/StyleAssistantWidget"));
const TavusConversation = lazy(() => import("./components/feature/TavusConversation"));
const DecartWidget = lazy(() => import("./components/feature/DecartWidget"));
import { applyConsent } from "./features/analytics";
// import SitePasswordGate from "./components/auth/SitePasswordGate";

function App() {
  return (
    <Suspense fallback={<div role="status" className="p-8 text-center">VADAURO</div>}>
    <I18nextProvider i18n={i18n}>
      <CartProvider>
        <OrderHistoryProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            {/* SitePasswordGate is temporarily bypassed for direct preview access. */}
            {/* <SitePasswordGate> */}
            <ScrollToTop />
            <TryOnSessionWatcher />
            <RouteMetadata />
            <BehaviorAnalytics />
            <AppRoutes />
            <Suspense fallback={null}>
            <DecartWidget />
            <StyleAssistantWidget />
            <TavusConversation />
            </Suspense>
            <CookieConsent onConsentChange={applyConsent} />
            {/* </SitePasswordGate> */}
          </BrowserRouter>
        </OrderHistoryProvider>
      </CartProvider>
    </I18nextProvider>
    </Suspense>
  );
}

export default App;
